
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { getPageStructureFromTree } from "@/lib/singularity/page-structure/page-structure";
import { documentStore, singularityStore } from "@/store/store";
import IconButton from "@/components/UI/IconButton.vue";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import Icon from "@/components/UI/Icon.vue";
import PageStructurePageListItem from "./PageStructurePageListItem.vue";

@Component({
  components: {
    IconButton,
    Dropdown,
    Icon,
    PageStructurePageListItem
  }
})
export default class PageStructureHeader extends Vue {
  get structure() {
    return getPageStructureFromTree(documentStore.document.tree);
  }

  get pages() {
    return singularityStore.pagesInWP.filter(page => page.postType === "page");
  }

  get pageTitle() {
    return documentStore.document.documentMeta.titleLabel;
  }

  get isHomepage() {
    return this.pageTitle.toLowerCase().includes("home");
  }

  openPagesPanel() {
    singularityStore.setSingularityLeftPanel("page_manager");
  }

  addSection() {
    singularityStore.setSectionAddOrSwapPanelState({
      mode: "add",
      sectionIdToAddAfterOrSwap: this.structure.length
        ? this.structure[this.structure.length - 1].nodeId
        : null
    });
    singularityStore.setSingularityLeftPanel("section_add_or_swap");
  }

  clearStructure() {
    documentStore.document.tree.root.children
      .map(child => {
        return child.id;
      })
      .forEach(id => {
        documentStore.deleteElement({ nodeId: id });
      });
  }
}
